module.exports = __webpack_public_path__ + "img/reset-poin.c606ffb8.png";